export default __webpack_public_path__ + "static/media/BasisGrotesquePro-Bold.99eb49b8.woff";